import { useFeatureFlagEnabled } from 'posthog-js/react'

/** PostHog flag that holds the word pocket back until it is ready for learners. */
export const WORD_POCKET_FLAG = 'word-pocket'

// Off until PostHog says otherwise: while flags load, or if they never load, the pocket stays hidden.
// Local dev servers run without a PostHog key, so flags never load there: always on in development.
export const useWordPocketEnabled = (): boolean => {
  const flag = useFeatureFlagEnabled(WORD_POCKET_FLAG) === true
  return flag || process.env.NODE_ENV === 'development'
}
